var map = {
	"./master-data/master-data.module": [
		"./src/app/master-data/master-data.module.ts",
		"default~master-data-master-data-module~retailer-retailer-module~salesrep-salesrep-module",
		"default~master-data-master-data-module~retailer-retailer-module",
		"master-data-master-data-module"
	],
	"./profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"profile-profile-module"
	],
	"./retailer/retailer.module": [
		"./src/app/retailer/retailer.module.ts",
		"default~master-data-master-data-module~retailer-retailer-module~salesrep-salesrep-module",
		"default~master-data-master-data-module~retailer-retailer-module",
		"retailer-retailer-module"
	],
	"./salesrep/salesrep.module": [
		"./src/app/salesrep/salesrep.module.ts",
		"default~master-data-master-data-module~retailer-retailer-module~salesrep-salesrep-module",
		"salesrep-salesrep-module"
	],
	"./user/user.module": [
		"./src/app/user/user.module.ts",
		"user-user-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;